var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { mergeQueryString, updateSearch } from 'bernie-core';
import { FILTER_URL_PARAM_PREFIX } from '../../../stores';
import { getFilteredObjectKeys } from '../../../helpers/common-helper';
export var SEE_ALL_CATEGORY = 'seeAll';
export var PRICE_CATEGORY = 'price';
export var CATEGORIES = 'categories';
export var getUpdatedFilterQueryObject = function (activitySearchStore) {
  var filterQueryObject = {};
  getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters).forEach(function (sortAndFilterKey) {
    var filterKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[sortAndFilterKey]);
    var filterParamKey = FILTER_URL_PARAM_PREFIX + sortAndFilterKey;
    var filteredKeys = filterKeys.filter(function (filterKey) {
      return activitySearchStore.sortAndFilterObject.filters[sortAndFilterKey][filterKey].selected;
    });
    if (sortAndFilterKey === CATEGORIES && activitySearchStore.selectedCategories && activitySearchStore.selectedCategories.length > 0) {
      activitySearchStore.selectedCategories.forEach(function (element) {
        filteredKeys.push(element);
      });
    }
    if (sortAndFilterKey === SEE_ALL_CATEGORY && filteredKeys.length > 0) {
      filterQueryObject[filterParamKey] = true;
    } else {
      filterQueryObject[filterParamKey] = filteredKeys.join(',');
    }
  });
  return filterQueryObject;
};
export function seeAllCheckboxClickHandler(filterKey, filterCategoryId, activitySearchStore, history, location, event, inDialog) {
  var checked = event.target.checked;
  var updatedFilterState = __assign({}, activitySearchStore.sortAndFilterObject.filters);
  updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = {
    selected: checked,
    enabled: true
  };
  if (checked) {
    var filterState_1 = {
      selected: !checked,
      enabled: true
    };
    var categoryKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters);
    categoryKeys.filter(function (categoryKey) {
      return categoryKey !== SEE_ALL_CATEGORY;
    }).forEach(function (categoryKey) {
      return getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[categoryKey]).forEach(function (filterKey) {
        return updatedFilterState[categoryKey][filterKey] = filterState_1;
      });
    });
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    var newQueryString = mergeQueryString(location.search, __assign({}, getUpdatedFilterQueryObject(activitySearchStore)));
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  }
}
export function checkboxClickHandler(filterKey, filterCategoryId, activitySearchStore, history, location, event, inDialog) {
  var checked = event.target.checked;
  var updatedFilterState = __assign({}, activitySearchStore.sortAndFilterObject.filters);
  if (checked) {
    updatedFilterState[filterCategoryId][filterKey] = {
      selected: checked,
      enabled: true
    };
    if (updatedFilterState[SEE_ALL_CATEGORY]) {
      updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = {
        selected: !checked,
        enabled: true
      };
    }
  }
  if (!checked) {
    var subCategoryKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[filterCategoryId], filterKey);
    subCategoryKeys.forEach(function (subCategory) {
      updatedFilterState[filterCategoryId][subCategory] = {
        selected: checked,
        enabled: true
      };
    });
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    var newQueryString = mergeQueryString(location.search, __assign({}, getUpdatedFilterQueryObject(activitySearchStore)));
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  }
}
export function radioFilterClickHandler(fieldId, fieldVal, activitySearchStore, history, location, inDialog) {
  var updatedFilterState = __assign({}, activitySearchStore.sortAndFilterObject.filters);
  Object.keys(updatedFilterState[fieldId]).forEach(function (filter) {
    updatedFilterState[fieldId][filter].selected = false;
  });
  if (updatedFilterState[SEE_ALL_CATEGORY]) {
    updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = {
      selected: false,
      enabled: true
    };
  }
  updatedFilterState[fieldId][fieldVal].selected = true;
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    var newQueryString = mergeQueryString(location.search, __assign({}, getUpdatedFilterQueryObject(activitySearchStore)));
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  }
}
export function getSelectedFieldValue(field, activitySearchStore) {
  var _a;
  if (!(field === null || field === void 0 ? void 0 : field.primary)) {
    return '';
  }
  var sortAndFilterObject = activitySearchStore.sortAndFilterObject.filters[(field === null || field === void 0 ? void 0 : field.options) && ((_a = field.options[0]) === null || _a === void 0 ? void 0 : _a.id) || ''];
  var filterKeys = Object.keys(sortAndFilterObject);
  var selectedKeys = filterKeys.filter(function (filter) {
    return sortAndFilterObject[filter].selected === true;
  });
  return selectedKeys.length > 0 ? selectedKeys[0] : filterKeys[0];
}